export default "__VITE_ASSET__DTaE96tQ__"